<template>
  <div
    class="app-content content"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  >
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <transition
      :name="routerTransition"
      mode="out-in"
    >
      <div
        class="content-area-wrapper"
        :data-route="$route.name"
        :class="contentWidth === 'boxed' ? 'container p-0' : null"
      >
        <slot name="breadcrumb">
          <app-breadcrumb />
        </slot>
        <portal-target
          name="content-renderer-sidebar-left"
          slim
        />
        <div
          class="content-right"
          :class="{'slide-in': appStore.isServiceContentVisible && $route.name === 'service-system'}"
        >
          <div class="content-wrapper">
            <div class="content-body">
              <slot />
            </div>
          </div>
        </div>
        <slot name="service" />
        <portal-target
          name="content-renderer-sidebar-right"
          slim
        />
      </div>
    </transition>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import useAppStore from '@/store-pinia/useAppStore'

export default {
  components: {
    AppBreadcrumb,
  },
  setup() {
    const appStore = useAppStore()
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth, appStore,
    }
  },
}
</script>

<style lang="scss">
.content-area-wrapper {
  &[data-route="service-system"] {
    position: relative;
    overflow: hidden;
    border: none !important;

    .footer {
      display: none !important;
    }

    .row {
      margin: 0 !important;
    }

    .content-right {
      position: absolute;
      width: 100%;
      height: 100%;
      right: 0;
      top: 0;
      z-index: 9;
      transform: translateX(100%);
      transition: transform 0.3s ease-out;
      background-color: white; // Added to ensure content is visible

      &.slide-in {
        transform: translateX(0);
      }

      .content-wrapper {
        opacity: 0;
        transition: opacity 0.3s ease-out;
        height: 100%;
      }

      &.slide-in .content-wrapper {
        opacity: 1;
      }
    }
  }
}

// .content-right {
//   position: relative;
//   width: auto;
// }
</style>
